module.exports = __webpack_public_path__ + "img/2.4bd317a6.png";